module.exports = __webpack_public_path__ + "img/2MV_5194.4d421b3a.jpg";